"use strict";

function e(e) {
  return e && "object" == typeof e && "default" in e ? e.default : e;
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var t = require("react"),
    n = require("downshift"),
    r = e(require("match-sorter")),
    o = e(require("react-highlight-words")),
    a = e(require("react-use/lib/useDeepCompareEffect")),
    l = require("@chakra-ui/form-control"),
    i = require("@chakra-ui/layout"),
    s = require("@chakra-ui/button"),
    u = require("@chakra-ui/input"),
    c = require("@chakra-ui/icons"),
    p = require("@chakra-ui/tag");

function g() {
  return (g = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function m(e, t) {
  return r(e, t, {
    keys: ["value", "label"]
  });
}

function d(e) {
  return t.createElement(i.Text, null, t.createElement(i.Box, {
    as: "span"
  }, "Create"), " ", t.createElement(i.Box, {
    as: "span",
    bg: "yellow.300",
    fontWeight: "bold"
  }, '"', e, '"'));
}

exports.CUIAutoComplete = function (e) {
  var r = e.items,
      b = e.optionFilterFunc,
      h = void 0 === b ? m : b,
      I = e.itemRenderer,
      f = e.highlightItemBg,
      y = void 0 === f ? "gray.100" : f,
      C = e.placeholder,
      x = e.label,
      S = e.listStyleProps,
      v = e.labelStyleProps,
      E = e.inputStyleProps,
      P = e.toggleButtonStyleProps,
      k = e.tagStyleProps,
      O = e.selectedIconProps,
      B = e.listItemStyleProps,
      T = e.onCreateItem,
      w = e.icon,
      j = e.hideToggleButton,
      q = void 0 !== j && j,
      F = e.disableCreateItem,
      R = void 0 !== F && F,
      L = e.createItemRenderer,
      V = void 0 === L ? d : L,
      D = e.renderCustomInput,
      M = function (e, t) {
    if (null == e) return {};
    var n,
        r,
        o = {},
        a = Object.keys(e);

    for (r = 0; r < a.length; r++) {
      t.indexOf(n = a[r]) >= 0 || (o[n] = e[n]);
    }

    return o;
  }(e, ["items", "optionFilterFunc", "itemRenderer", "highlightItemBg", "placeholder", "label", "listStyleProps", "labelStyleProps", "inputStyleProps", "toggleButtonStyleProps", "tagStyleProps", "selectedIconProps", "listItemStyleProps", "onCreateItem", "icon", "hideToggleButton", "disableCreateItem", "createItemRenderer", "renderCustomInput"]),
      W = t.useState(!1),
      A = W[0],
      H = W[1],
      K = t.useState(""),
      _ = K[0],
      U = K[1],
      z = t.useState(r),
      G = z[0],
      J = z[1],
      N = t.useRef(null),
      Q = n.useMultipleSelection(M),
      X = Q.getSelectedItemProps,
      Y = Q.getDropdownProps,
      Z = Q.addSelectedItem,
      $ = Q.removeSelectedItem,
      ee = Q.selectedItems,
      te = ee.map(function (e) {
    return e.value;
  }),
      ne = n.useCombobox({
    inputValue: _,
    selectedItem: void 0,
    items: G,
    onInputValueChange: function onInputValueChange(e) {
      var t = e.selectedItem,
          n = h(r, e.inputValue || "");
      A && n.length > 0 && H(!1), t || J(n);
    },
    stateReducer: function stateReducer(e, t) {
      var r = t.changes;

      switch (t.type) {
        case n.useCombobox.stateChangeTypes.InputBlur:
          return g({}, r, {
            isOpen: !1
          });

        case n.useCombobox.stateChangeTypes.InputKeyDownEnter:
        case n.useCombobox.stateChangeTypes.ItemClick:
          return g({}, r, {
            highlightedIndex: e.highlightedIndex,
            inputValue: _,
            isOpen: !0
          });

        case n.useCombobox.stateChangeTypes.FunctionSelectItem:
          return g({}, r, {
            inputValue: _
          });

        default:
          return r;
      }
    },
    onStateChange: function onStateChange(e) {
      var t = e.inputValue,
          o = e.selectedItem;

      switch (e.type) {
        case n.useCombobox.stateChangeTypes.InputChange:
          U(t || "");
          break;

        case n.useCombobox.stateChangeTypes.InputKeyDownEnter:
        case n.useCombobox.stateChangeTypes.ItemClick:
          o && (te.includes(o.value) ? $(o) : T && A ? (T(o), H(!1), J(r), U("")) : Z(o), ge(null));
      }
    }
  }),
      re = ne.isOpen,
      oe = ne.getToggleButtonProps,
      ae = ne.getLabelProps,
      le = ne.getMenuProps,
      ie = ne.getInputProps,
      se = ne.getComboboxProps,
      ue = ne.highlightedIndex,
      ce = ne.getItemProps,
      pe = ne.openMenu,
      ge = ne.selectItem,
      me = ne.setHighlightedIndex;

  return t.useEffect(function () {
    0 !== G.length || R || (H(!0), J([{
      label: "" + _,
      value: _
    }]), me(0));
  }, [G, H, me, _, R]), a(function () {
    J(r);
  }, [r]), t.createElement(i.Stack, null, t.createElement(l.FormLabel, Object.assign({}, g({}, ae({}), v)), x), ee && t.createElement(i.Stack, {
    spacing: 2,
    isInline: !0,
    flexWrap: "wrap"
  }, ee.map(function (e, n) {
    return t.createElement(p.Tag, Object.assign({
      mb: 1
    }, k, {
      key: "selected-item-" + n
    }, X({
      selectedItem: e,
      index: n
    })), t.createElement(p.TagLabel, null, e.label), t.createElement(p.TagCloseButton, {
      onClick: function onClick(t) {
        t.stopPropagation(), $(e);
      },
      "aria-label": "Remove menu selection badge"
    }));
  })), t.createElement(i.Stack, Object.assign({
    isInline: !0
  }, se()), D ? D(g({}, E, ie(Y({
    placeholder: C,
    onClick: re ? function () {} : pe,
    onFocus: re ? function () {} : pe,
    ref: N
  }))), g({}, P, oe(), {
    ariaLabel: "toggle menu",
    hideToggleButton: q
  })) : t.createElement(t.Fragment, null, t.createElement(u.Input, Object.assign({}, E, ie(Y({
    placeholder: C,
    onClick: re ? function () {} : pe,
    onFocus: re ? function () {} : pe,
    ref: N
  })))), !q && t.createElement(s.Button, Object.assign({}, P, oe(), {
    "aria-label": "toggle menu"
  }), t.createElement(c.ArrowDownIcon, null)))), t.createElement(i.Box, {
    pb: 4,
    mb: 4
  }, t.createElement(i.List, Object.assign({
    bg: "white",
    borderRadius: "4px",
    border: re && "1px solid rgba(0,0,0,0.1)",
    boxShadow: "6px 5px 8px rgba(0,50,30,0.02)"
  }, S, le()), re && G.map(function (e, n) {
    return t.createElement(i.ListItem, Object.assign({
      px: 2,
      py: 1,
      borderBottom: "1px solid rgba(0,0,0,0.01)"
    }, B, {
      bg: ue === n ? y : "inherit",
      key: "" + e.value + n
    }, ce({
      item: e,
      index: n
    })), A ? V(e.label) : t.createElement(i.Box, {
      display: "inline-flex",
      alignItems: "center"
    }, te.includes(e.value) && t.createElement(i.ListIcon, Object.assign({
      as: w || c.CheckCircleIcon,
      color: "green.500",
      role: "img",
      display: "inline",
      "aria-label": "Selected"
    }, O)), I ? I(e) : t.createElement(o, {
      autoEscape: !0,
      searchWords: [_ || ""],
      textToHighlight: (r = e, r.label)
    })));
    var r;
  }))));
};